import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-mist py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-149" data-mp="1iw341efukb5e">
      <div className="mx-auto max-w-6xl px-4" data-id="element-150" data-mp="1dxjfd69vcl9c">
        <div className="text-center" data-id="element-151" data-mp="1dunhfhy0twkw">
          <span className="inline-flex items-center gap-2 rounded-md bg-navy px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-safety" data-id="element-152" data-mp="2bkih3vff4je3">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-153" data-mp="26j2tbvluvys0" /> Los {totalVolumes} tomos
          </span>
          <h2 id="modules-title" className="mx-auto mt-4 max-w-3xl text-balance text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-154" data-mp="21nvyzeeh86fr">
            Una guía completa por cada dimensión de la Seguridad e Higiene laboral
          </h2>
        </div>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-155" data-mp="l7jinupiuehk">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.12
          }} transition={{
            duration: 0.3,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="card-deep flex flex-col overflow-hidden rounded-xl border border-steel text-onDark shadow-card" data-id="element-156" data-mp="1ite288oupiv4" data-mpi={index}>
                <div className="hazard-bar h-1.5 w-full" aria-hidden="true" data-id="element-157" data-mp="14xaft1k7yet7" />
                <div className="flex flex-1 flex-col p-6" data-id="element-158" data-mp="q8ea3b5mxdvr">
                  <div className="flex items-start justify-between gap-4" data-id="element-159" data-mp="v4uxu48x9q8b">
                    <span className="flex h-11 w-11 items-center justify-center rounded-md bg-safety text-navyDeep" data-id="element-160" data-mp="h5vbx4csnpfu">
                      <Icon className="h-6 w-6" aria-hidden="true" data-id="element-161" data-mp="l7zyxk8qlnti" />
                    </span>
                    <span className="font-display text-xs font-extrabold uppercase tracking-[.16em] text-mutedDark" data-id="element-162" data-mp="2nunhzxnktvlq">
                      Tomo {module.number}
                    </span>
                  </div>
                  <h3 className="mt-5 text-lg font-extrabold uppercase leading-tight text-white" data-id="element-163" data-mp="2e3kih0aapook">{module.title}</h3>
                  <p className="mt-2 text-sm font-semibold text-safety" data-id="element-164" data-mp="296ka2ipz49ua">{module.subtitle}</p>
                  <p className="mt-3 text-sm leading-relaxed text-mutedDark" data-id="element-165" data-mp="36ryh9i97kp16">{module.description}</p>
                  <p className="mt-4 flex-1 rounded-lg border-l-4 border-prevention bg-prevention/10 p-3 text-sm leading-relaxed text-onDark" data-id="element-166" data-mp="31uyat68g5k9j">
                    <b className="font-extrabold text-prevention" data-id="element-167" data-mp="2wwocwnvc85k8">Resultado: </b>
                    {module.result}
                  </p>
                  <div className="mt-auto flex flex-col gap-3 border-t border-steel pt-4" data-id="element-168" data-mp="1lfx0zu4bne65">
                    <span className="inline-flex items-center gap-1.5 self-start rounded-md bg-safety/15 px-3 py-1 text-xs font-extrabold text-safety" data-id="element-169" data-mp="1hdju32du9a7s">
                      <FileTextIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-170" data-mp="3t39hy75py8en" /> {module.note}
                    </span>
                    <p className="text-[10px] font-extrabold uppercase tracking-[.1em] text-mutedDark/80" data-id="element-171" data-mp="5wpccs16kby6">{module.tags}</p>
                  </div>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-navy px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-172" data-mp="fn1ukdlivt15">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-safety" data-id="element-173" data-mp="kk23cw9rb9vy">Total de la colección principal</p>
          <p className="font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-174" data-mp="olduj68a4369">
            {totalVolumes} tomos <span className="mx-2 text-safety" data-id="element-175" data-mp="2qel7i90f68oz">·</span> Contenido normativo actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}